import type { Meeting } from "../types";

export function isCancelledMeeting(meeting: Meeting) {
  return ["CANCELLED", "CANCELADA"].includes(meeting.status.toUpperCase());
}

function meetingTime(meeting: Meeting) {
  return meeting.starts_at ? new Date(meeting.starts_at).getTime() : Number.POSITIVE_INFINITY;
}

export function nextMeeting(meetings: Meeting[], now = new Date()) {
  const timestamp = now.getTime();
  return [...meetings]
    .filter((meeting) => !meeting.archived_at && !isCancelledMeeting(meeting) && meeting.starts_at && meetingTime(meeting) >= timestamp)
    .sort((left, right) => meetingTime(left) - meetingTime(right))[0];
}

export function groupMeetingHistory(meetings: Meeting[], now = new Date()) {
  const timestamp = now.getTime();
  const active = meetings.filter((meeting) => !meeting.archived_at);
  return {
    upcoming: active
      .filter((meeting) => !meeting.starts_at || meetingTime(meeting) >= timestamp)
      .sort((left, right) => meetingTime(left) - meetingTime(right)),
    past: active
      .filter((meeting) => meeting.starts_at && meetingTime(meeting) < timestamp)
      .sort((left, right) => meetingTime(right) - meetingTime(left)),
  };
}
